function setWindowConfigData () {
  let configData = {
    HTTPURL: '', // 请求地址
    HTTPURLCAPI: '', // 请求地址capi
    HTTPURLDSAPI: '', // 数据服务API地址
    h5Login: '', // 登陆地址
    h5Bm: '', // 下单地址
    appId: 'xdfztApp', // appId
    systemSource: 'xdf_zt',
    originUrl: 'https://www.xdf.cn/zhuanti/b0marketing/index.html#/',  // 正式线分享链接
    wxlogin: '',  // 微信授权地址
    highEndDomain: '', // 高端域名地址
    promotion: 'mms.xdf.cn',
    promotionTestOne: 'nzhaosh-promth5-zstest1.test.xdf.cn',
    promotionTestTwo: 'nzhaosh-promth5-zstest2.test.xdf.cn',
    promotionTestThree: 'nzhaosh-promth5-zstest3.test.xdf.cn',
    appIdWechat: 'wechat',
    ucenter: 'https://uc-k12studentinfo.xdf.cn',
    soukeWebUrl: 'https://m.souke.xdf.cn', // 搜课网地址
  }

  if (window.location.hostname === 'localhost' ) {
    // configData.HTTPURL = 'https://activity.test.xdf.cn'
    configData.HTTPURL = '//capi.test.xdf.cn'
    configData.HTTPURLCAPI = 'https://dcapi.test.xdf.cn'
    configData.HTTPURLDSAPI = 'https://dsapi.test.xdf.cn'
    // configData.h5Login = 'https://testu2.staff.xdf.cn/i/m2/mobileLogin.aspx'
    configData.h5Login = 'https://login-t.test.xdf.cn/sso/login?app_id=souke&response_type=&scope=&state=&switch_account=&ehr_org_id=105'
    configData.h5Bm = 'https://th5bm.test.xdf.cn'
    configData.originUrl = 'https://mobile.test.xdf.cn/zhuanti/b0marketing/index.html#/'
    configData.wxlogin = 'https://twechat.test.xdf.cn/wxlogin/xdf?appId=e-activity&bindPassport=false&switchAccount=false'
    configData.bm = 'http://gateway.test.xdf.cn'
    configData.highEndDomain = 'https://th5vipnis.test.xdf.cn'
    configData.appIdWechat = 'test'
    configData.ucenter = 'https://uc-k12studentinfo.test.xdf.cn'
    configData.soukeWebUrl = 'https://msouke.test.xdf.cn' // 测试环境搜课网地址
  } else if (window.location.hostname === 'mobile.test.xdf.cn' || window.location.hostname === 'ecommerce-mobile-test1.test.xdf.cn'||window.location.hostname === 'mtoutiao.test.xdf.cn'|| window.location.hostname === 'aa.test.xdf.cn') {
    // 测试:
    configData.HTTPURL = 'https://capi.test.xdf.cn'
    configData.HTTPURLCAPI = 'https://dcapi.test.xdf.cn'
    configData.HTTPURLDSAPI = 'https://dsapi.test.xdf.cn'
    // configData.h5Login = 'https://testu2.staff.xdf.cn/i/m2/mobileLogin.aspx'
    configData.h5Login = 'https://login-t.test.xdf.cn/sso/login?app_id=e-activity&response_type=&scope=&state=&switch_account=&ehr_org_id=105'
    configData.h5Bm = 'https://th5bm.test.xdf.cn'
    configData.originUrl = 'https://mobile.test.xdf.cn/zhuanti/b0marketing/index.html#/'
    configData.wxlogin = 'https://twechat.test.xdf.cn/wxlogin/xdf?appId=e-activity&bindPassport=false&switchAccount=false'
    configData.bm = 'https://gateway.test.xdf.cn'
    configData.highEndDomain = 'https://th5vipnis.test.xdf.cn'
    configData.appIdWechat = 'test'
    configData.ucenter = 'https://uc-k12studentinfo.test.xdf.cn'
    configData.soukeWebUrl = 'https://msouke.test.xdf.cn' // 测试环境搜课网地址
  } else if (window.location.hostname === 'www.xdf.cn') {
    // 上线：
    // configData.HTTPURL = 'https://activity.xdf.cn'
    configData.HTTPURL = 'https://capi.xdf.cn'
    configData.HTTPURLCAPI = 'https://capi.xdf.cn'
    configData.HTTPURLDSAPI = 'https://dsapi.xdf.cn'
    // configData.h5Login = 'https://passport.xdf.cn/i/m2/MobileLogin.aspx'
    configData.h5Login = 'https://login.xdf.cn/sso/login?app_id=e-activity&response_type=&scope=&state=&switch_account=&ehr_org_id=105'
    configData.h5Bm = 'https://h5bm.xdf.cn'
    configData.originUrl = 'https://www.xdf.cn/zhuanti/b0marketing/index.html#/'
    configData.wxlogin = 'https://wxpay.xdf.cn/wxlogin/xdf?appId=e-activity&bindPassport=false&switchAccount=false'
    configData.bm = 'https://gateway.xdf.cn'
    configData.highEndDomain = 'https://h5vipnis.xdf.cn'
    configData.appIdWechat = 'wechat'
    configData.ucenter = 'https://uc-k12studentinfo.xdf.cn'
  }
  return configData
}
const configData = setWindowConfigData()
export default configData
